module.exports = __webpack_public_path__ + "img/vertical_3_7_6000.cb9e13ff.png";